import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { YambaRootState } from '../store';

interface UserState {
  userType: string | null,
  studentRequestId?: string | null
}

const initialState: UserState = {
  userType: null,
  studentRequestId: null
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    resetUser() {
      return initialState;
    },
    setUserType(state, action: PayloadAction<string>) {
      // eslint-disable-next-line no-param-reassign
      state.userType = action.payload;
    }
  }
});

export const getUserType = (state: YambaRootState) => state.user.userType;

export const {
  resetUser,
  setUserType
} = userSlice.actions;
export default userSlice.reducer;
